module.exports = __webpack_public_path__ + "static/media/daily-pricing-icon.3a3e4903.svg";